export const industrys = [
  {
    theme: "owner",
    label: "homePage.guard.guard-ui.brand",
    color: "#215AE5",
    icon: "website-authing-logo",
    thirdIcon: ["icon-wechat.png", "icon-google.png", "icon-twitter.png"],
  },
  {
    theme: "technology",
    label: "homePage.guard.guard-ui.tech",
    color: "#215ae5",
    icon: "website-kejiyelogo",
    thirdIcon: ["icon-feishu.png", "icon-wecom.png", "icon-zabbix.png"],
  },
  {
    theme: "manufacture",
    label: "homePage.guard.guard-ui.manual",
    color: "#FF9459",
    icon: "website-zhizaoyelogo",
    thirdIcon: ["icon-dingding.png", "icon-wecom.png", "icon-github.png"],
  },
  {
    theme: "finance",
    label: "homePage.guard.guard-ui.finance",
    color: "#759DFF",
    icon: "website-jinronglogo",
    thirdIcon: ["icon-express.png", "icon-wecom.png", "icon-tongdun.png"],
  },
];
